// Action Cable provides the framework to deal with WebSockets in Rails.
// You can generate new channels where WebSocket features live using the `bin/rails generate channel` command.

import { Consumer, getConfig, INTERNAL } from "@rails/actioncable";
import { EasyChannelHelper } from "./helper";

class EasyConsumer extends Consumer {
  get helper() {
    return new EasyChannelHelper();
  }
}

export default new EasyConsumer(getConfig("url") || INTERNAL.default_mount_path);
